import Component from '../classes/component';

const SELECTORS = {
  closeButton: '.modal-exit',
};

class Modal extends Component<typeof SELECTORS> {
  protected _selectors = SELECTORS;

  protected _modalId: string;

  private _triggers: globalThis.NodeListOf<HTMLButtonElement>;

  public open() {
    this.container.classList.add('open');
  }

  public close() {
    this.container.classList.remove('open');
  }

  protected _onEnter() {
    this._modalId = this.container.id;
    const selector = `[data-modal-id="${this._modalId}"]`;
    this._triggers = document.querySelectorAll<HTMLButtonElement>(selector);

    this._addListener(Array.from(this._triggers), 'click', this.open);
    this._addListener('closeButton', 'click', this.close);
  }
}

export default Modal;
